async function getApiKey(variableName) {
    try {
        const module = await import("./apiKeys");
        console.log(module[variableName])
        console.log(module)
        return module[variableName];
    } catch (error) {
        console.error(`Error importing or accessing variable: ${error}`);
        return undefined;
    }
}

const accessToken = (window.location.origin.includes("localhost")  || window.location.origin.includes("192.168")) ? await getApiKey("mapboxApiKey") : process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
const firebaseToken = (window.location.origin.includes("localhost") || window.location.origin.includes("192.168")) ? await getApiKey("firebaseApiKey") :process.env.REACT_APP_FIREBASE_TOKEN
export { accessToken, firebaseToken }